module.exports = __webpack_public_path__ + "@/assets/img/adecco-logo.9a11ef92.svg";